import { Outlet, createRootRoute, Link, type ErrorComponentProps } from "@tanstack/react-router";

export const Route = createRootRoute({
  component: RootShell,
  errorComponent: RootError,
});

function RootShell() {
  return <Outlet />;
}

// Global safety net: any render throw or uncaught route error lands here instead
// of white-screening the whole SPA. Route-level errorComponents (if added) take
// precedence over this.
function RootError({ error, reset }: ErrorComponentProps) {
  return (
    <div className="app-error" role="alert">
      <div className="app-error-card">
        <h1>Something went wrong</h1>
        <p className="muted">An unexpected error occurred while rendering this page. You can retry, or head back to the start.</p>
        {error?.message && <pre className="app-error-detail">{error.message}</pre>}
        <div className="app-error-actions">
          <button type="button" className="primary" onClick={() => reset()}>
            Try again
          </button>
          <Link to="/" className="app-error-home">
            Go home
          </Link>
        </div>
      </div>
    </div>
  );
}
